import { type EmailTemplate } from '@/types/EmailTemplate'
import { createEmailTemplate } from '@/factories/emailTemplateFactory'

export const EmailTemplateModel = {
  create: createEmailTemplate,

  validate(template: EmailTemplate): boolean {
    return (
      !!template.name &&
      !!template.subject &&
      !!template.html &&
      this.isValidTemplateName(template.name)
    )
  },

  isValidTemplateName(name: string): boolean {
    const validNameRegex = /^[a-zA-Z0-9\-_~%#@]+$/
    return name.length > 0 && name.length <= 1500 && validNameRegex.test(name)
  },

  interpolate(template: string, data: Record<string, unknown>): string {
    return template.replace(/{{\s*([\w.]+)\s*}}/g, (_, key) => {
      return (
        key.split('.').reduce((obj: Record<string, unknown>, k: string) => obj?.[k], data) ?? ''
      )
    })
  },

  formatPreview(template: EmailTemplate, data: Record<string, unknown> = {}): string {
    return this.interpolate(template.html, data)
  },

  getDefaultSampleData(): Record<string, unknown> {
    return {
      firstName: 'John',
      lastName: 'Doe',
      organization: {
        name: 'Sample Company',
      },
      transaction: {
        total: '$1,000.00',
        date: new Date().toLocaleDateString(),
      },
    }
  },
}
